export enum TipoDeReceita {
  VENDAS_A_VISTA = 'VENDAS_A_VISTA',
  VENDAS_A_PRAZO = 'VENDAS_A_PRAZO',
  JUROS_RECEBIDOS = 'JUROS_RECEBIDOS',
  DESCONTOS_RECEBIDOS = 'DESCONTOS_RECEBIDOS',
  DEVOLUCAO_DE_FORNECEDOR = 'DEVOLUCAO_DE_FORNECEDOR',
  OUTROS = 'OUTROS',
}
